import { ComponentStyleConfig } from "@chakra-ui/react";
import { theme as chakraTheme } from "@chakra-ui/theme";
import inputTheme from "theme/components/InputTheme";

const SelectTheme: ComponentStyleConfig = {
  baseStyle: {
    field: {
      lineHeight: "20px",
      _disabled: {
        opacity: 0.5,
      },
    },
    icon: {
      color: "gray.500",
      _disabled: {
        opacity: "unset",
      },
    },
  },
  variants: {
    simple: {
      field: {
        fontSize: "14px",
        pl: "16px",
        // @ts-expect-error exported type is broken
        ...inputTheme.variants["simple"]["field"],
        _invalid: {
          borderColor: "error.600",
        },
        "&[data-blank]": {
          color: "gray.400",
        },
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      },
      icon: {
        width: "24px",
        height: "24px",
        right: "12px",
        bg: "white",
        _disabled: {
          opacity: 0.5,
        },
      },
    },
  },
  sizes: {
    md: (props) => {
      if (props.variant === "simple") {
        return {};
      }
      return {
        field: {
          fontSize: "14px",
          padding: "20px 48px 8px 16px !important",
        },
        icon: {
          width: "16px",
          height: "16px",
          right: "16px",
        },
      };
    },
  },
  parts: chakraTheme.components.Select.parts,
};

export default SelectTheme;
